export enum ServiceActionTypes {
    API_RESPONSE_SUCCESS = '@@service/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@service/API_RESPONSE_ERROR',

    GET_SERVICES = '@@service/GET_SERVICES',
    RESET = '@@service/RESET',
    GET_SERVICE_DETAILS = '@@user/GET_SERVICE_DETAILS',
    UPDATE_SERVICE = '@@user/UPDATE_SERVICE',
    ADD_SERVICE = '@@user/ADD_SERVICE',
    DELETE_SERVICE = '@@user/DELETE_SERVICE',
}
